module.exports = __webpack_public_path__ + "img/carousel1.d534280a.png";